<template>
  <div
  class="outputBox"
  :class="{'headerOutput': from == 'header'}"
  v-loading="loadingFlag">
    <div class="mediaTitle">
      <span v-if="from == 'workbench'">{{$t("lang.Output")}}</span>
      <el-input
        class="searchInput"
        v-model="searchItem"
        @input='handleInput'
        clearable
        suffix-icon="el-icon-search"></el-input>
      <span
        @click="closeOutputDialog"
        v-if="from !== 'workbench'"
        class="closeBtn el-icon-close"></span>
    </div>
    <!-- output列表 -->
    <Output
    @closeLoading="closeLoading"
    :from="from"
    :ProgramItem="ProgramItem"></Output>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
import Output from './Output.vue'
import debounce from 'lodash.debounce'
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    // 从哪里进入
    from: {
      type: String,
      default: 'workBench'
    },
    // 频道信息
    ProgramItemData: {
      type: Object,
      default: () => ({
        name: '',
        format: '',
        coverUrl: '',
        region: ''
      })
    }
  },
  data () {
    return {
      // 频道ID
      targetId: '',
      // 频道信息
      ProgramItem: {},
      openObj: {
        show: false,
        type: 'social' // social/output
      },
      showSocialTitle: false,
      loadingFlag: true,
      importedLen: 0,
      searchItem: ''
    }
  },
  components: {
    Output
  },
  created () {
    this.handleInput = debounce(this.handleInput, 300)
    if (this.from == 'workbench') {
      this.ProgramItem = this.ProgramItemData
      this.ProgramItem.ProgramId = this.ProgramItem.id
    } else {
      this.ProgramItem = Outil.getProgramReceiver()
      this.ProgramItem.rid = this.ProgramItem.peerId
      this.ProgramItem.id = this.ProgramItem.ProgramId
    }
    this.targetId = this.ProgramItem.ProgramId
    Bus.$on('openSocialList', (obj) => {
      this.openSocialList(obj)
    })
  },
  methods: {
    closeLoading () {
      this.loadingFlag = false
    },
    handleInput () {
      mediaObj.updataSocial({ nickName: this.searchItem })
    },
    // 关闭output弹框
    closeOutputDialog () {
      Bus.$emit('closeHeaderOutput')
    },
    getImportedLen (len) {
      this.importedLen = len
    },
    openSocialList (obj) {
      this.openObj = JSON.parse(JSON.stringify(obj))
      this.openObj.type = obj.show ? obj.type : ''
    }
  }
}
</script>
<style lang="less" scoped>
.outputBox {
  .OutputEdit{
    width: 330px;
    // padding: 0 24px;
    // min-height: 583px;
    max-height: 800px;
    overflow-y: hidden;
    position: absolute;
    left: 580px;
    top: -92px;
    background: #252525;
    box-shadow: 0px 0px 15px 0px rgba(16, 4, 0, 0.72);
    border-radius: 8px;
  }
  &.headerOutput {
    width: 400px;
    position: absolute;
    height: 300px;
    top: 64px;
    right: 10px;
    background: #252525;
    padding: 10px 30px 10px;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);
    z-index: 10;
    .OutputEdit {
      left: -330px;
      top: 0;
    }
  }
}

</style>
